import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { BlogCardComponent } from '../blog-card/blog-card.component';
@Component({
    selector: 'blogs-list',
    templateUrl: './blogs-list.component.html',
    styleUrls: ['./blogs-list.component.scss'],
    //animations: slideUp,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BlogCardComponent],
    standalone: true,
})
export class BlogsListComponent {
    blogs = input([]);
    cardDirection = input<'ver' | 'hor'>('hor');
}
